export default __webpack_public_path__ + "static/media/mod-dinle.76f69b41.png";